<!-- Card -->
<div
    class="relative z-10 bg-white rounded-3xl shadow-xl px-10 py-12 w-full mx-4 text-center flex flex-col items-center gap-6">

    <!-- Illustration -->
    <img src="assets/construction.png" alt="Under Construction" class="w-[70%] select-none" />

    <!-- Title -->
    <h1 class="text-2xl md:text-3xl font-bold text-blue-950">
        {{ 'common.underConstruction.title' | transloco }}
    </h1>

    <!-- Description -->
    <p class="text-gray-500 text-base leading-relaxed">
        {{ 'common.underConstruction.detail' | transloco }}
    </p>

    <!-- Back button -->
    <a routerLink="/home"
        class="mt-2 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-400 hover:bg-blue-950 text-blue-900 hover:text-white font-semibold text-sm shadow-md transition-all duration-300">
        <i class="pi pi-home text-base"></i>
        {{ 'common.underConstruction.goHome' | transloco }}
    </a>

</div>